import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_CRM_URL, IMAGE_URL_IBIZ } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

import "../../Config/loading.css";
import { useLabelContext } from "../../../Context";
import { Footer } from "../footer/footer";
// import { useProductContext } from "../context/productcontext";

export default function SingleProduct() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  // const { selectedProduct } = useProductContext();
  //   const [products, setProducts] = useState([]);
  //   const [userDataSession, setUserDataSession] = useState({});
  //   const { setID } = useLabelContext();

  //   useEffect(() => {
  //     const userDataString = sessionStorage.getItem("MisUserDetails")||localStorage.getItem("MisUserDetails");
  //     if (userDataString) {
  //       const userData = JSON.parse(userDataString);
  //       setUserDataSession(userData);
  //     } else {
  //       console.log("User data not found in sessionStorage");
  //       navigate('/');
  //     }
  //   }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  //   const filteredItems = useMemo(() => {
  //     const results = products.filter(
  //       (item) =>
  //         item.ProductName.toLowerCase().includes(searchTerm.toLowerCase())

  //     );

  //     setCurrentPage(1);

  //     return results;
  //   }, [products, searchTerm]);

  //   const indexOfLastItem = currentPage * itemsPerPage;
  //   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  //   const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  //   const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //   const formatDate = (dateString) => {
  //     const date = new Date(dateString);
  //     const day = String(date.getDate()).padStart(2, "0");
  //     const month = String(date.getMonth() + 1).padStart(2, "0");
  //     const year = date.getFullYear();

  //     return `${day}-${month}-${year}`;
  //   };

  //   useEffect(() => {
  //     const fetchProducts = async () => {
  //       setLoading(true)
  //       try {
  //         const response = await fetch('https://qaibizapi.ibizaccounts.in/Product/GetProducts', {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //           },
  //           body: JSON.stringify({
  //             OrgId: userDataSession.OrgId,
  //             Id: "0",
  //             CategoryId: "0",
  //             BarCode: "0"
  //           }),
  //         });

  //         const data = await response.json();
  //         console.log(data)
  //         if (Array.isArray(data.ResultData)) {
  //           setProducts(data.ResultData);
  //           setLoading(false)
  //         } else {
  //           console.error('API response is not an array:', data);
  //           setProducts([]);

  //         }
  //       } catch (error) {
  //         console.error('Error:', error);

  //       }
  //     };
  //     if (userDataSession?.OrgId) {
  //       fetchProducts();
  //     }
  //   }, [userDataSession.OrgId]);


  const [selectedProduct, setSelectedProduct] = useState({});

  useEffect(() => {
    const stored = sessionStorage.getItem("selectedProduct");
    if (stored) {
      try {
        setSelectedProduct(JSON.parse(stored));
      } catch (e) {
        console.error("Failed to parse selectedProduct from sessionStorage", e);
        navigate("/products");
      }
    } else {

      navigate("/products");
    }
  }, [navigate]);

  // useEffect(() => {
  //   return () => sessionStorage.removeItem("selectedProduct");
  // }, []);

  return (
    <Base>
      {/* <div className="page-header">
        <div className="add-item d-flex">
          <div className="page-title">
            <h3>Products</h3>
            <h6>Manage your Products</h6>
          </div>
        </div>
      </div>
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <input
                  type="text"
                  name="search"
                  placeholder="Search..."
                  className="form-control"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="card-container">
            {loading ? (
              <div className="text-center my-5">
                <div className="containers m-auto d-flex justify-content-center align-items-center">
                  <div className="dot bg-primary"></div>
                  <div className="dot bg-secondary"></div>
                  <div className="dot bg-success"></div>
                  <div className="dot bg-danger"></div>
                  <div className="dot bg-warning"></div>
                  <div className="dot bg-info"></div>
                </div>
                <p className="mt-3">Loading...</p>
              </div>
            ) : (
              currentItems && currentItems.map((item, index) => (
                <div key={index} className="product-card card shadow-lg my-3" style={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  transform: 'scale(1)',
                  transition: 'transform 0.3s ease-in-out',
                }} onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>

                  <div className="card-body" style={{
                    padding: '16px',
                  }}>
                    <div className="d-flex" style={{
                      alignItems: 'flex-start',
                      gap: '20px',
                    }}>
                      <img
                        src={`${IMAGE_URL_IBIZ}${item.ImagePath}`}
                        alt="Product"
                        style={{
                          width: '100px',
                          height: '100px',
                          objectFit: 'cover',
                          borderRadius: '12px',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        }}
                      />
                      <div>
                        <h5 className="card-title" style={{
                          color: '#007bff',
                          fontSize: '18px',
                          fontWeight: '600',
                        }}>{item.ProductName}</h5>
                        <div className="d-flex align-items-center" style={{

                          fontSize: '14px',
                        }}>
                          <i className="fa-solid fa-table-columns" style={{
                            marginRight: '8px',
                            color: '#007bff',
                          }}></i>
                          {item.CategoryName}
                        </div>
                        <div style={{

                          fontSize: '14px',
                        }}><i class="fa-solid fa-barcode" style={{
                          color: '#007bff',
                          marginRight: '8px',
                        }}></i>
                          {item.BarCode || 'N/A'}</div>
                        <div style={{
                          fontSize: '16px',
                        }}>
                          <i className="fa-solid fa-indian-rupee-sign" style={{
                            color: '#007bff',
                            marginRight: '8px',
                          }}></i>{item.MRP}</div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div> */}
      <div style={{ padding: "20px" }}>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          {selectedProduct.ImagePath ? (
            <img
              src={`${IMAGE_URL_IBIZ}${selectedProduct.ImagePath}`}
              alt="Product"
              style={{
                maxWidth: "100%",
                height: "200px",
                objectFit: "cover",
                borderRadius: "12px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              }}
            />
          ) : (
            <div
              style={{
                width: "200px",
                height: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "64px",
                fontWeight: "bold",
                color: "#ffffff",
                backgroundColor: "#041243",
                borderRadius: "12px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                margin: "0 auto", // Center placeholder div
              }}
            >
              {selectedProduct.ProductName?.charAt(0).toUpperCase()}
            </div>
          )}
        </div>
        <p
          style={{
            textAlign: "center",
            fontSize: "24px",
            marginBottom: "10px",
            color: "#060b25",
          }}
        >
          <strong>{selectedProduct.ProductName}</strong>
        </p>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ flex: "1", paddingRight: "10px" }}>
            <p style={{ fontSize: "15px", marginBottom: "5px" }}>
              <strong>Category:</strong> {selectedProduct.CategoryName}
            </p>
            <p style={{ fontSize: "15px", marginBottom: "5px" }}>
              <strong>Code:</strong> {selectedProduct.code}
            </p>
            <p style={{ fontSize: "15px", marginBottom: "5px" }}>
              <strong>Avg Price:</strong> {selectedProduct.AvgPrice}
            </p>
            <p style={{ fontSize: "15px", marginBottom: "5px" }}>
              <strong>Weight:</strong> {selectedProduct.Weight}
            </p>
            <p style={{ fontSize: "15px", marginBottom: "5px" }}>
              <strong>HSN:</strong> {selectedProduct.HSN || "N/A"}
            </p>
          </div>
          <div style={{ flex: "1", paddingLeft: "10px" }}>
            <p style={{ fontSize: "15px", marginBottom: "5px" }}>
              <strong>Price:</strong> {selectedProduct.MRP}
            </p>
            <p style={{ fontSize: "15px", marginBottom: "5px" }}>
              <strong>Barcode:</strong> {selectedProduct.BarCode || "N/A"}
            </p>
            <p style={{ fontSize: "15px", marginBottom: "5px" }}>
              <strong>Car Code:</strong> {selectedProduct.CatCode || "N/A"}
            </p>
            <p style={{ fontSize: "15px", marginBottom: "5px" }}>
              <strong>All Stock:</strong> {selectedProduct.AllStock || "N/A"}
            </p>
            <p style={{ fontSize: "15px", marginBottom: "5px" }}>
              <strong>SKU:</strong> {selectedProduct.ProductSKU || "N/A"}
            </p>
          </div>
        </div>
      </div>

      <br></br>
      <br></br>
      <Footer></Footer>
    </Base>
  );
}